import { Component, Input, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { DriverStateAggData } from 'src/app/moov-common/services/data/data-data';
import { AbstractMotivationsService } from 'src/app/moov-common/services/motivation/motivations.abstract.service';

@Component({
  selector: 'app-side-nav-driver-breakdown-list',
  templateUrl: './side-nav-driver-breakdown-list.component.html',
  styleUrl: './side-nav-driver-breakdown-list.component.scss',
})
export class SideNavDriverBreakdownListComponent extends BaseComponent {
  @Input() drivers: DriverStateAggData[] = [];

  constructor(public motivationService: AbstractMotivationsService) {
    super();
  }

  getMotivationIconName(motivationId: string): string {
    return this.motivationService.getMotivationIconName(motivationId);
  }

  getMotivationName(motivationId: string): string {
    return this.motivationService.getMotivationName(motivationId);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.ifChanged(changes.drivers, () => {
      this.updateDrivers();
    });
  }

  private updateDrivers(): void {
    this.drivers = this.drivers.map((driver) => ({
      ...driver,
      motivationIconName: this.getMotivationIconName(driver.driverId),
      motivationName: this.getMotivationName(driver.driverId),
      progressBarColorString: this.calculateProgressBarColor(driver.score),
    }));
    this.sortDriversByImpact();
  }

  private sortDriversByImpact(): void {
    this.drivers = this.drivers.sort((a, b) => b.count - a.count);
  }

  calculateProgressBarColor(driverScore: number): string {
    return this.utilsService.calculateProgressBarColor(driverScore);
  }
}
